export default [
  {
    code: 'ru',
    title: 'Русский',
    img: getImgByLang('ru'),
  },
  {
    code: 'en',
    title: 'English',
    img: getImgByLang('en'),
  },
  {
    code: 'uz',
    title: `O'zbek`,
    img: getImgByLang('uz'),
  },
];

function getImgByLang(lang) {
  return require(`../../assets/img/langs/${lang}.jpg`);
}
